<template>
    <div id="app" @click="overall">
        <!-- <template v-if="!is_pc">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive" v-wechat-title='$route.meta.title'></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive" v-wechat-title='$route.meta.title'></router-view>
        </template>
        <template v-else>
           请用手机打开
        </template> -->

        <!-- 非法版本 -->
        <template v-if="!is_support">

            <u8d_header></u8d_header>
            <div class="f-tip">
                <p>您正在使用的浏览器版本过低，将不能正常浏览和使用u8D质量云平台。</p>
                <p>为了您能正常使用网站功能,请点击下载并使用这些浏览器。</p>
            </div>
            <div class="ex-list">
                <ul>
                    <li @click="opne_url('https://www.google.cn/chrome/thank-you.html?statcb=1&installdataindex=empty&defaultbrowser=0')">
                        <img src="./assets/img/chrome.png" alt=""/>
                        <span>Chrome</span>
                    </li>
                    <li @click="opne_url('https://download-ssl.firefox.com.cn/releases-sha2/stub/official/zh-CN/Firefox-latest.exe')">
                        <img src="./assets/img/firefox.png" alt=""/>
                        <span>Firefox</span>
                        <a href="#"></a>
                    </li>
                    <li @click="opne_url('https://www.apple.com/cn/safari/')">
                        <img src="./assets/img/safari.png" alt=""/>
                        <span>Safari</span>
                        <a href="#"></a>
                    </li>
                    <li @click="opne_url('https://www.opera.com/download/get/?partner=www&opsys=Windows&arch=x64')">
                        <img src="./assets/img/opera.png" alt=""/>
                        <span>Opera</span>
                        <a href="#"></a>
                    </li>
                    <li @click="opne_url('https://go.microsoft.com/fwlink/?LinkId=324629')">
                        <img src="./assets/img/ie.png" alt=""/>
                        <span>IE11及以上</span>
                        <a href="#"></a>
                    </li>
                    <div class="clear">

                    </div>
                </ul>
            </div>

        </template>

        <template v-else>

            <template v-if="$route.meta.empty&&$route.meta.empty!=undefined">
                <template v-if="!is_pc">
                    <!--缓存想要缓存的页面，实现后退不刷新-->
                    <!--加上v-if的判断，可以自定义想要缓存的组件，自定义在router里面-->
                    <keep-alive>
                        <router-view v-if="$route.meta.keepAlive" v-wechat-title='$route.meta.h5?$route.meta.title:"u8D质量云平台"'></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.keepAlive" v-wechat-title='$route.meta.h5?$route.meta.title:"u8D质量云平台"'></router-view>
                </template>
                <template v-else>
                    <!--缓存想要缓存的页面，实现后退不刷新-->
                    <!--加上v-if的判断，可以自定义想要缓存的组件，自定义在router里面-->
                    <keep-alive>
                        <router-view v-if="$route.meta.keepAlive" v-wechat-title='$route.meta.h5?$route.meta.title:"u8D质量云平台"'></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.keepAlive" v-wechat-title='$route.meta.h5?$route.meta.title:"u8D质量云平台"'></router-view>
                </template>
            </template>
            <template v-if="!$route.meta.empty&&$route.meta.empty===undefined">

                <div :class="'u8d-main-conten'">

                <div class="app-header" v-if="$route.meta.public">
                    <div class="logo-info">
                        <img src="./assets/img/logo.png" alt="" />
                        <span>{{this.$store.getters.companyInfo!=undefined?this.$store.getters.companyInfo.name:'u8D质量云平台'}}</span>
                    </div>
                    <div class="main-tab">
                        <span :class="this.$store.getters.indexNavAft == '/index'?'aft':''" @click="url_go('/index')">首页</span>
                        <i class="nav-quick-btn" @click="nav_add">新增问题</i>
                        <!-- <span>知识库</span> -->
                        <!-- <span>模板汇</span> -->
                        <!-- <span>认证处</span> -->
                    </div>
                    <div class="user-info">
                        <div class="fun-btn">
                            <span><a style="color:#999;" download="u8D【质量云平台】系统操作手册_V1.0.pdf" href="./static/u8D【质量云平台】系统操作手册_V1.0.pdf">帮助</a></span>
                            |
                            <span @click.stop="show_msg">
                                消息
                                <i v-if="unReadNum>0">{{unReadNum>9?'9+':unReadNum}}</i>
                            </span>
                        </div>
                        <div class="portrait" @click.stop="show_menu">
                            <img :src="this.$store.getters.userDetileInfo==undefined?'static/img/img_avatar.png':''||this.$store.getters.userDetileInfo.avatar!=null?this.$store.getters.userDetileInfo.avatar:'static/img/img_avatar.png'" alt="">

                            <div class="user-meun-box" v-if="menu_show" @click.stop>
                                <img src="./assets/img/msg_icon.png" alt="" />
                                <p @click="url_go('/user/user_center')">个人中心</p>
                                <p @click="logout">退出</p>
                            </div>
                        </div>
                        <div class="home-new-list" v-if="msg_show" @click.stop>
                            <img src="./assets/img/msg_icon.png" alt="" />
                            <div class="home-new-list-title">
                                消息
                            </div>
                            <div class="home-new-list-box-main">
                                <!-- 滚动条 -->
                                <vue-scroll :ops="ops" @handle-scroll="handleScroll">
                                <div class="home-new-list-box">
                                    <template v-if="messageList.length>0">
                                        <div v-for="(item,index) in messageList" :key="index" @click="jump_details(item)">
                                            <i v-if="item.status==0"></i>
                                            <p>{{item.title}}&nbsp;-&nbsp;{{item.sponsorName}}（{{$comm.time_out_second(item.deadline)}}）</p>
                                            <b>{{item.timeStatus}}  ></b>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <p class="no_data">暂无消息</p>
                                    </template>
                                </div>
                                </vue-scroll>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="app-base-main-conten" :style="'height:'+clientHeight+'px'" v-if="$route.meta.public">

                    <div class="base-main-left" :style="'height:'+clientHeight+'px'">
                        <template v-if="this.$store.getters.indexNavAft.indexOf('/index') != -1">
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/my_task') != -1?'aft':''" @click="url_go('/index/my_task')">我的任务</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/solve_task') != -1?'aft':''" @click="url_go('/index/solve_task')">解决问题</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/find_task') != -1?'aft':''" @click="url_go('/index/find_task')">发现问题</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/mail_colleague') != -1||this.$store.getters.indexNavAft.indexOf('/index/mail_partner') != -1?'':''" @click="url_go('/index/mail_colleague')">通讯录</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/mail_colleague') != -1?'aft':''" @click="url_go('/index/mail_colleague')" style="padding-left:80px">同事</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/mail_partner') != -1?'aft':''" @click="url_go('/index/mail_partner')" style="padding-left:80px">合作伙伴</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/find_summary') != -1||this.$store.getters.indexNavAft.indexOf('/index/find_summary') != -1?'':''" @click="url_go('/index/find_summary')">部门报表</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/find_summary') != -1?'aft':''" @click="url_go('/index/find_summary')" style="padding-left:80px">发现问题汇总</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/index/solve_summary') != -1?'aft':''" @click="url_go('/index/solve_summary')" style="padding-left:80px">解决问题汇总</div>
                        </template>
                        <template v-if="this.$store.getters.indexNavAft.indexOf('/user/') != -1">
                            <div :class="this.$store.getters.indexNavAft.indexOf('/user/user_center') != -1?'aft':''" @click="url_go('/user/user_center')">个人中心</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/user/user_set') != -1||this.$store.getters.indexNavAft.indexOf('/user/user_signature') != -1||this.$store.getters.indexNavAft.indexOf('/user/user_company') != -1?'':''" @click="url_go('/user/user_set')">设置</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/user/user_set') != -1?'aft':''" @click="url_go('/user/user_set')" style="padding-left:80px">密码重置</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/user/user_signature') != -1?'aft':''" @click="url_go('/user/user_signature')" style="padding-left:80px">电子签名</div>
                            <div :class="this.$store.getters.indexNavAft.indexOf('/user/user_company') != -1?'aft':''" @click="url_go('/user/user_company')" style="padding-left:80px">切换公司</div>
                        </template>
                    </div>

                    <div class="base-main-right" >
                        <!-- 汇总页面tabs -->
                        <!-- <div class="summary-nav" v-if="$route.meta.summary">
                            <el-button size="small" :type="$route.meta.title == '首页'?'primary':''" @click="url_go('/index')">个人汇总</el-button>
                            <el-dropdown>
                                <el-button size="small" :type="$route.meta.title == '部门汇总'?'primary':''">
                                    部门汇总<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item >
                                        <div @click="url_go('/index/find_summary')">发现问题</div>
                                    </el-dropdown-item>
                                    <el-dropdown-item >
                                        <div @click="url_go('/index/solve_summary')">解决问题</div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div> -->
                        <keep-alive>
                            <router-view v-if="$route.meta.keepAlive" wechat-title='u8D质量云平台'></router-view>
                        </keep-alive>
                        <router-view v-if="!$route.meta.keepAlive" wechat-title='u8D质量云平台'></router-view>
                    </div>
                    
                    <div class="clear"></div>
                    
                </div>

                <template v-else>
                    <!--缓存想要缓存的页面，实现后退不刷新-->
                    <!--加上v-if的判断，可以自定义想要缓存的组件，自定义在router里面-->
                    <keep-alive>
                        <router-view v-if="$route.meta.keepAlive" v-wechat-title='$route.meta.h5?$route.meta.title:"u8D质量云平台"'></router-view>
                    </keep-alive>
                    <router-view v-if="!$route.meta.keepAlive" v-wechat-title='$route.meta.h5?$route.meta.title:"u8D质量云平台"'></router-view>
                </template>


                </div>

            </template>

        </template>
    </div>
</template>

<script>
import Vue from 'vue';
import vuescroll from 'vuescroll/dist/vuescroll-native';
import u8d_header from './components/header/header.vue';
Vue.use(vuescroll);
import { DropdownMenu, DropdownItem ,Dropdown} from 'element-ui'
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Dropdown);

export default {
    components: {
        u8d_header,
    },
    data(){

        
        return{
            is_pc:true,
            clientHeight:0,
            rightWhith:0,
            ops: {
                vuescroll: {
                    wheelScrollDuration: 500,
                    mode: 'native',
                    pullRefresh: {
                        enable: true
                    },
                    pushLoad: {
                        enable: false,
                        tips: {
                            deactive: 'Push to Load',
                            active: 'Release to Load',
                            start: 'Loading...',
                            beforeDeactive: 'Load Successfully!'
                        },
                        auto: true,
                        autoLoadDistance: 0
                    },
                },
                bar:{
                    background:'#999',
                    keepShow:false,
                    size:'4px',
                    opacity:0.7,
                    showDelay:1000
                },
                rail:{
                    gutterOfSide:'5px',
                    gutterOfEnds:'16px',
                },
            },
            messageList:[],
            unReadNum:0,

            msg_show:false,
            menu_show:false,
            is_support:true,
            mescurrent:1,
            no_mess:false

        }
    },

    
    methods: {

        url_go:function(url){
            var _this = this;
            this.dingDingView(()=>{
                _this.$router.push({path:url});
                if(url==='/index'){
                    //副tab  key
                    // this.$store.dispatch('setIndexNavAftFun','/index');
                }
            })
        },

        logout:function(){
            var _this = this;
            this.dingDingView(()=>{
                _this.$api.login.logout({},e=>{

                    _this.$message({
                        message: '退出登录成功',
                        type: 'success'
                    });
                    _this.$router.push({path:'/login'});
                    
                })
            })
        },
        show_msg:function(){
            var msg_show = this.msg_show;
            if(msg_show){
                this.msg_show = false;
            }else{
                this.msg_show = true;
            }
        },
        show_menu:function(){
            var menu_show = this.menu_show;
            if(menu_show){
                this.menu_show = false;
            }else{
                this.menu_show = true;
            }
        },
        nav_add() {
            if(!this.$store.getters.userInfo.username){
                this.$message({
                    message: '请先完善个人信息，便于任务流转通知',
                    type: 'warning'
                });
                return;
            }
            var _this = this;
            this.dingDingView(()=>{
                //改变问题详情状态
                _this.$store.dispatch('setTaskDetileFun', false);
                _this.$router.push({ path: '/index/find_task_add' })
            })
        },
        //跳转到详情
        jump_details:function(val){

            // 更新消息状态
            this.$api.user.update({
                messageId:val.messageId,
                status:1,
            },e=>{
                //取得消息
                this.$eventHub.$emit(this.$evekey['GET_MESSAGE']);
            });
                // console.log(val)
            this.$store.dispatch('setMyTaskIdFun', val);
            this.$store.dispatch('setReportDetailFun', val);
            this.$router.push({ path: '/index/messg_routes?type=' + val.type })
            // if (val.type == 1||val.type ==2) {

            //     if(this.$store.getters.aftPath == '/index/my_task_detailsall'){
            //         this.$router.push({ path: '/index/my_task_detailsall_hulk?type=' + val.type })
            //     }else{
            //         this.$router.push({ path: '/index/my_task_detailsall?type=' + val.type })
            //     }

            // } else {
            //     if(this.$store.getters.aftPath == '/index/my_task_details'){
            //         this.$router.push({ path: '/index/my_task_details_hulk?type=' + val.type })
            //     }else{
            //         this.$router.push({ path: '/index/my_task_details?type=' + val.type  })
            //     }
                
            // }

            this.msg_show = false;
            
        },
        //退出登录
        logout:function(){
            var _this = this;
            this.dingDingView(()=>{
                _this.$api.user.logout({},e=>{
                    _this.$message({
                        message: '退出登录成功',
                        type: 'success'
                    });

                    window.localStorage.removeItem('LOGIN');
                    _this.$router.push({path:'/login'});
                })
            })
        },

        //全局点击事件
        overall:function(){
            this.msg_show = false;
            this.menu_show = false;
            this.$eventHub.$emit(this.$evekey['OVERALL']);

        },
        
        //消息触低事件
        handleScroll(vm, dom, done) {
            let process = vm.process;
            let list = this.messageList;
            if(process==1&&!this.no_mess){

                this.mescurrent=this.mescurrent+1;

                // 取得消息列表
                this.$api.user.messageList({
                    current:this.mescurrent,
                    size:20
                },e=>{
                    list.push(...e.messageList);
                    this.messageList = list;
                    if(e.messageList.length!=20){
                        this.no_mess = true;
                    }
                })
                
            }
        },

        //钉钉绑定界面提示语句
        dingDingView(back = () => {}){
            // if(this.$store.getters.corpId && this.$store.getters.token == ''){
                
            //     this.$message({
            //         message: '请先保存手机号',
            //         type: 'warning'
            //     });

            //     return
            // }

            back();
        }

    },

    beforeCreate:function(){
       
    },

    mounted:function(){
        var _this = this;

        this.$eventHub.$on(this.$evekey['OVERALL'],()=>{
            this.menu_show = false;
        });

        //判断浏览器版本是否合法
        var IEVersion = this.$comm.IEVersion();
        if(IEVersion!=-1&&IEVersion!=11&&IEVersion!='edge'){
            this.is_support = false;
            window.document.body.style.backgroundColor = '#f2f2f3';
        }

        // 检测浏览器路由改变页面不刷新问题,hash模式的工作原理是hashchange事件
        window.addEventListener('hashchange', () => {
            let currentPath = window.location.hash.slice(1)
            if (this.$route.path !== currentPath) {
                this.$router.push(currentPath)
            }
        }, false);

        // 获取浏览器可视区域高度
        _this.clientHeight =   window.innerHeight-80;          //document.body.clientWidth;
        _this.rightWhith =   window.innerWidth-224;          //document.body.clientWidth;
        window.onresize = function () {

            _this.clientHeight = window.innerHeight-80;
            _this.rightWhith = window.innerWidth-224;

            //最小宽度
            var rightWhith = _this.rightWhith;
            if((rightWhith+224)<1366){
                _this.rightWhith = 1366-224;
            }

        }

        // if(this.$store.getters.token.corpId){
        //     setInterval(() => {
        //         _this.clientHeight = window.innerHeight-80;
        //         _this.rightWhith = window.innerWidth-224;

        //         //最小宽度
        //         var rightWhith = _this.rightWhith;
        //         if((rightWhith+224)<1366){
        //             _this.rightWhith = 1366-224;
        //         }
        //     }, 1000);
        // }

        // //最小宽度
        // var rightWhith = _this.rightWhith;
        // if((rightWhith+224)<1366){
        //     _this.rightWhith = 1366-224;
        // }

        //判断是手机还是pc
        if(navigator.platform.indexOf('Win32')!=-1){
            // console.log("是在电脑");
            //Toast("是在电脑", 10000);
            this.is_pc=true
            return true;
        }else{
            // console.log("是在手机");
            // Toast("是在手机", 10000);
            this.is_pc=false
            return false;
        };
        

    },
    created(){

        var _this = this;

        //刷新时设置缓存
        window.addEventListener("beforeunload",()=>{

            window.sessionStorage.setItem("app_store",JSON.stringify(_this.$store.state.app))
            window.sessionStorage.setItem("api_data_list",JSON.stringify(_this.$store.state.api))

        });

        if(sessionStorage.getItem("api_data_list")!=null){
            //读取缓存数据
            _this.$store.state.api = JSON.parse(sessionStorage.getItem("api_data_list"));
        }

        this.$eventHub.$on(this.$evekey['GET_MESSAGE'],()=>{
            this.no_mess = false;
            this.mescurrent = 1;
            // 取得消息列表
            this.$api.user.messageList({
                current:this.mescurrent,
                size:20
            },e=>{
                this.messageList = e.messageList;
                this.unReadNum = e.unReadNum;
                if(e.messageList.length!=20){
                    this.no_mess = true;
                }
            })
        });

       
        
    }
}
</script>

<style lang="scss">

    /* $prompt/$alert 弹窗层级提升至 u8d_pop(z-index:9999) 之上 */
    .el-message-box__wrapper{
        z-index: 10001 !important;
    }

    .summary-nav{
        padding: 16px 30px;
        background-color: #fff;
        margin-left: 1px;
        font-size: 0;
        .el-button{
            margin-right: 8px;
        }
    }

    .u8d-main-conten{
        min-width: 1366px;
    }
    .el-input.is-disabled .el-input__inner{
        background-color: #f6f6f6
    }
    .el-table::before {
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
}   
    .app-header{
        height: 80px;
        background-color: #fff;
        box-shadow:  0 0 3px rgba($color: #000000, $alpha: .4);
        position: relative;
        z-index: 1996;
        .logo-info{
            height: 80px;
            padding-top: 16px;
            padding-bottom: 16px;
            margin-left: 8px;
            display: inline-block;
            float: left;
            img{
                width: 48px;
                height: 48px;
                vertical-align: middle;
            }
            span{
                vertical-align: middle;
                font-size: 18px;
                color: #434349;
                font-weight: bold;
                margin-left: 16px;
                display: inline-block;
                width: 150px;
                @include ellipsis;
            }
        }
        .main-tab{
            height: 80px;
            padding-top: 12px;
            padding-bottom: 12px;
            display: inline-block;
            float: left;
            margin-left: 36px;

            span{
               display: inline-block;
               width: 100px;
               height: 56px;
               line-height: 56px;
               cursor: pointer;
               font-size: 16px;
               color: #999;
            }

            span.aft{
                color: $main-color;
            }
        }
        .user-info{
            position: relative;
            float: right;
            &>div{
                display: inline-block;
            }
            .fun-btn{
                vertical-align: middle;
                color: #999;
                span{
                    font-size: 12px;
                    padding: 0 4px;
                    &:hover{
                        text-decoration: underline
                    }
                    cursor: pointer; 
                    position: relative;
                    i{
                        display: inline-block;
                        width: 40px;
                        height: 30px;
                        border-radius: 30px;
                        position: absolute;
                        right: -25px;
                        top: -15px;
                        background: $main-color;
                        text-align: center;
                        font-size: 20px;
                        line-height: 30px;
                        color: #fff;
                        transform:scale(.5,.5);
                    }
                }
            }
            .portrait{
                width: 45px;
                height: 45px;
                margin: 17.5px 16px;
                border-radius: 45px;
                background-color: #eee;
                vertical-align: middle;
                position: relative;
                cursor: pointer;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 100%;
                }
                .user-meun-box{
                    width: 136px;
                    background-color: #fff;
                    position: absolute;
                    right: 0px;
                    box-shadow: 0px 0px 10px rgb(221, 221, 221);
                    border: 1px solid #eee;
                    border-radius: 4px;
                    top: 62px;
                    z-index: 1997;
                    &>img{
                        height: 18px;
                        width: 16px;
                        position: absolute;
                        top: -16px;
                        right: 14px;
                    }
                    p{
                        height: 40px;
                        line-height: 40px;
                        padding-left: 24px;
                        border-bottom: 1px solid #eee;
                    }
                    p+p{
                        border: none;
                    }
                }
            }
        }

        .nav-quick-btn{
            background-color: $main-color;
            display: inline-block;
            color: #fff;
            padding: 4px 6px;
            font-size: 14px;
            border-radius: 2px;
            position: relative;
            left: -50px;
            cursor: pointer;
        }
    }

    .app-base-main-conten{
        .base-main-left{
            width: 224px;
            background-color: #fff;
            float: left;
            padding-top: 32px;
            position: absolute;
            &>div{
                padding-left: 54px;
                color: #666;
                height: 40px;
                line-height: 40px;
                font-size: 14px;
                cursor: pointer;
            }
            &>div.aft{
                // background-color: $main-color;
                color: $main-color;
                font-weight: bold;
            }
        }
        .base-main-right{
            float: left;
            height: 100%;
            width: 100%;
            padding-left: 224px;
            overflow-y: scroll;
        }
    }

    .app-foot{
        text-align: center;
        width: 100%;
        min-width: 1128px;
        padding-bottom: 32px;
        background-color: #f2f2f3;
        p{
            text-align: center;
            font-size: 12px;
            color: #999;
        }
        div {
            text-align: center;
            padding: 5px 0;
            a{
                color: $main-color;
                margin: 0 5px;
                cursor: pointer;
            }
            a:hover{
                text-decoration:underline
            }
        }
    }

    .home-new-list{
        width: 500px;
        background-color: #fff;
        position: absolute;
        right: 16px;
        top: 78px;
        box-shadow: 0px 0px 10px rgb(221, 221, 221);
        border: 1px solid #eee;
        border-radius: 4px;
        &>img{
            height: 18px;
            width: 16px;
            position: absolute;
            top: -18px;
            right: 70px;
        }

        .home-new-list-title{
            height: 48px;
            line-height: 48px;
            padding-left: 24px;
            border-bottom: 1px solid #eee;
            font-size: 20px;
        }
        .home-new-list-box-main{
            height: 400px;
            min-height: 400px;
        }
        .home-new-list-box{
            width: 496px;
            div{
                width: 100%;
                height: 40px;
                padding-left: 24px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-right: 24px;
                border-bottom: 1px solid #eee;
                position: relative;
                cursor: pointer;
                i{
                    display: inline-block;
                    width: 6px !important;
                    height: 6px !important;
                    background-color: $main-color;
                    border-radius: 6px !important;
                    position: absolute;
                    left: 10px;
                }
                i.no{
                    background-color: #fff;
                }
                p{
                    width: 150%;
                    @include ellipsis;
                    font-size: 12px;
                }
                b{
                    display: inline-block;
                    width: 40%;
                    text-align: right;
                    font-size: 12px;
                }
            }
            .no_data{
                text-align: center;
                padding: 10px;
                color: #999; 
            }
        }
    }
    .f-tip{
        text-align: center;
        font-size: 18px;
        padding-top: 120px;
        color: #333;
    }
    .ex-list{
        padding-top: 60px;
        ul{
            width: 900px;
            margin: 0 auto;
        }
        li{
            float: left;
            width: 100px;
            margin: 0 40px;
            cursor: pointer;
            position: relative;
            overflow: hidden;
            a{
                display: inline-block;
                width: 100%;
                height: 150px;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 99;
            }
            span{
                padding-top: 20px;
                display: inline-block;
                width: 100px;
                text-align: center;
            }
        }
        img{
            width: 100px;
            height: 100px;
        }
    }
</style>




// WEBPACK FOOTER //
// src/App.vue